var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCall = function SvgIconCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-call_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "M4.5 16.502v-7H3a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.2,
    d: "M2.5 9.501c0-6.8 5-8.166 7.5-8 1.83 0 5.098.985 6.42 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "M15.5 16.502v-7H17a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2zm0 0v.5a2 2 0 0 1-2 2H10"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 19.002,
    r: 1.5,
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-call_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .501h20v20H0z"
  })))));
};
export { SvgIconCall as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMCAyMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik00LjUgMTYuNTAxNVY5LjUwMTQ2SDNDMS44OTU0MyA5LjUwMTQ2IDEgMTAuMzk2OSAxIDExLjUwMTVWMTQuNTAxNUMxIDE1LjYwNiAxLjg5NTQzIDE2LjUwMTUgMyAxNi41MDE1SDQuNVoiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuMiIvPgo8cGF0aCBkPSJNMi41IDkuNTAxM0MyLjUgMi43MDEzIDcuNSAxLjMzNDYzIDEwIDEuNTAxM0MxMS44MzA2IDEuNTAxMzIgMTUuMDk3NSAyLjQ4NjIgMTYuNDIwMiA2LjAwMTIyIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTUuNSAxNi41MDE1VjkuNTAxNDZIMTdDMTguMTA0NiA5LjUwMTQ2IDE5IDEwLjM5NjkgMTkgMTEuNTAxNVYxNC41MDE1QzE5IDE1LjYwNiAxOC4xMDQ2IDE2LjUwMTUgMTcgMTYuNTAxNUgxNS41Wk0xNS41IDE2LjUwMTVWMTcuMDAxNUMxNS41IDE4LjEwNiAxNC42MDQ2IDE5LjAwMTUgMTMuNSAxOS4wMDE1SDEwIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjIiLz4KPGNpcmNsZSBjeD0iMTAiIGN5PSIxOS4wMDE1IiByPSIxLjUiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwLjUwMTQ2NSkiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K";